<template>
  <div class="contact-info">
    <h3 class="contact-info-title">{{ title }}</h3>
    <div class="contact-info-items">
      <a :href="`tel:${phoneDigits}`" class="contact-info-item">
        <span class="contact-info-icon contact-info-icon--phone">
          <img
          src="/assets/images/icon/phone-icon.svg"
          :alt="t('layout.footer.main.phoneLabel')"
          width="24"
          height="24"
          loading="lazy"
          decoding="async"
        >
        </span>
        <span class="contact-info-text">{{ phone }}</span>
      </a>
      <a :href="`mailto:${email}`" class="contact-info-item">
        <span class="contact-info-icon contact-info-icon--email">
          <img
          src="/assets/images/icon/mail-icon.svg"
          :alt="t('layout.footer.main.emailLabel')"
          width="24"
          height="24"
          loading="lazy"
          decoding="async"
        >
        </span>
        <span class="contact-info-text">{{ email }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

interface Props {
  title?: string
  phone?: string
  email?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  phone: '0 69 02 03 03',
  email: 'contact@rvs.md'
})

const title = computed(() => props.title ?? t('pages.contacts.contactInfo.title'))
const phoneDigits = computed(() => (props.phone ?? '').replace(/\s/g, ''))
</script>

<style scoped>
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* max-width: 428px; */
}

.contact-info-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  color: var(--color-dark-blue);
  margin: 0;
}

.contact-info-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-info-item {
  display: flex;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  color: var(--color-grey);
  font-family: var(--font-inter);
  font-size: var(--font-size-body);
  line-height: 1.6;
  transition: color 0.2s ease;
}

.contact-info-item:hover {
  color: var(--color-teal);
}

.contact-info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  border-radius: 50%;
  border: 0.5px solid var(--color-grey-light);
  /* background-color: #f0f0f0; */
}

.contact-info-icon img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.contact-info-text {
  flex: 1;
}
</style>
